<template>
  <Print v-if="isPrint" :form="form" />
  <div v-else>
    <!--기본정보-->
    <field-select-module v-model="form.stdInfo" :board="this.board" :is-print="isPrint" />

    <!--    수행업무 내용-->
    <div class="mt-28px">
      <h5 class="mb-4"><i class="dot"></i>수행업무 내용</h5>
      <div class="writeGridContainer">
        <div>
          <div>작업인원</div>
          <span v-if="isPrint" class="print-input"> {{ form.inputB_1 }} </span>
          <comma-input v-else :readonly="board.readonly" v-model="form.inputB_1" type="number" />
        </div>
        <div>
          <div>작업시간</div>
          <div class="time">
            <time-selector v-model="form.inputB_2" />
            <span>~</span>
            <time-selector v-model="form.inputB_3" />
          </div>
        </div>
        <div>
          <div>교육제목</div>
          <span v-if="isPrint" class="print-input"> {{ form.inputB_4 }} </span>
          <ml-input v-else :readonly="board.readonly" v-model="form.inputB_4" />
        </div>

        <div class="mt-2">
          <div>교대작업 유무</div>
          <div class="w-full flex-1 flex gap-4">
            <vs-radio v-model="form.inputB_5" :disabled="board.readonly" vs-value="유" vs-name="radios1">유</vs-radio>
            <vs-radio v-model="form.inputB_5" :disabled="board.readonly" vs-value="무" vs-name="radios1">무</vs-radio>
          </div>
        </div>
        <div class="mt-2">
          <div>특별안전보건교육</div>
          <div class="w-full flex-1 flex gap-4">
            <vs-radio v-model="form.inputB_6" :disabled="board.readonly" vs-value="유" vs-name="radios2">유</vs-radio>
            <vs-radio v-model="form.inputB_6" :disabled="board.readonly" vs-value="무" vs-name="radios2">무</vs-radio>
          </div>
        </div>

        <div class="writeGridLineItem mt-2">
          <div>위험기계·기구 보유현황</div>
          <p v-if="isPrint" class="w-full flex-1">{{ form.inputB_7 }}</p>
          <ml-textarea :readonly="board.readonly" v-else v-model="form.inputB_7" class="flex-1 w-full" rows="5" />
        </div>
        <div class="writeGridLineItem">
          <div>유해·위험물질 보유현황</div>
          <p v-if="isPrint" class="w-full flex-1">{{ form.inputB_8 }}</p>
          <ml-textarea :readonly="board.readonly" v-else v-model="form.inputB_8" class="flex-1 w-full" rows="5" />
        </div>
        <div class="writeGridLineItem">
          <div>위험요인/전달사항</div>
          <p v-if="isPrint" class="w-full flex-1">{{ form.inputB_9 }}</p>
          <ml-textarea :readonly="board.readonly" v-else v-model="form.inputB_9" class="flex-1 w-full" rows="5" />
        </div>
      </div>
    </div>

    <!--    재해자 현황-->
    <table-custom
      :board="board"
      :is-print="isPrint"
      title="재해자 현황"
      :tableData="[
        { id: 'input1', title: '발생일', type: 'date', placeholder: '작성일', width: '150px' },
        { id: 'input2', title: '성명', type: 'text', placeholder: '내용', width: '150px' },
        { id: 'input3', title: '연령', type: 'text', placeholder: '내용', width: '150px' },
        { id: 'input4', title: '발생시간', type: 'time', placeholder: '시간', width: '150px' },
        { id: 'input5', title: '발생원인', type: 'text', placeholder: '내용' },
        { id: 'input6', title: '조치결과', type: 'text', placeholder: '내용' },
      ]"
      v-model="form.victimList"
    />

    <TableInspectMerge :is-print="isPrint" :is-readonly="board.readonly" title="점검사항" tableHeaderTitle="점검사항" :isNote="false" v-model="form.inspectList" class="mt-5" />

    <div class="mt-28px">
      <div class="writeGridContainer">
        <div class="col-span-6 flex items-center">
          <div>문제점</div>
          <span v-if="isPrint" class="print-input"> {{ form.inputC_1 }} </span>
          <ml-input v-else :readonly="board.readonly" v-model="form.inputC_1" />
        </div>
        <div class="col-span-6 flex items-center">
          <div>개선사항</div>
          <span v-if="isPrint" class="print-input"> {{ form.inputC_2 }} </span>
          <ml-input v-else :readonly="board.readonly" v-model="form.inputC_2" />
        </div>
        <div class="writeGridLineItem mt-2">
          <div>특이사항</div>
          <p v-if="isPrint" class="w-full flex-1">{{ form.inputC_3 }}</p>
          <ml-textarea :readonly="board.readonly" v-else v-model="form.inputC_3" class="flex-1 w-full" rows="5" placeholder="예) 위험성평가 종사자 의견 수렴, 교육, 위험성 제거․대체․통제 대책 마련 종사자 의견수렴" />
        </div>
      </div>
    </div>

    <!--    결재-->
    <div class="mt-28px">
      <h5 class="mb-4"><i class="dot"></i>결재</h5>
      <div class="writeGridContainer">
        <div>
          <div>담당</div>
          <span v-if="isPrint" class="print-input"> {{ form.inputD_1 }} </span>
          <ml-input v-else :readonly="board.readonly" v-model="form.inputD_1" />
        </div>
        <div>
          <div class="title">서명</div>
          <div>
            <SignField class="w-full" v-model="form.inputD_2" :readonly="board.readonly" />
          </div>
        </div>
      </div>
      <div class="writeGridContainer">
        <div>
          <div>결재</div>
          <span v-if="isPrint" class="print-input"> {{ form.inputD_3 }} </span>
          <ml-input v-else :readonly="board.readonly" v-model="form.inputD_3" />
        </div>
        <div>
          <div class="title">서명</div>
          <div>
            <SignField class="w-full" v-model="form.inputD_4" :readonly="board.readonly" />
          </div>
        </div>
      </div>
    </div>

    <!--    협조-->
    <div class="mt-28px">
      <h5 class="mb-4"><i class="dot"></i>협조</h5>
      <div class="writeGridContainer">
        <div class="writeGridLineItem mt-2">
          <div>협조</div>
          <p v-if="isPrint" class="w-full flex-1">{{ form.inputE_1 }}</p>
          <ml-input v-else :readonly="board.readonly" v-model="form.inputE_1" />
        </div>
      </div>
    </div>

    <!--    사진대지-->
    <photo-upload-grid-module :row-count="2" :grid-count="2" v-model="form.photoList" :is-print="isPrint" :readonly="board.readonly" />

    <!--파일첨부-->
    <file-upload-module :readonly="board.readonly" v-model="form.fileList" class="mt-5" :is-print="isPrint" />
  </div>
</template>

<script>
import FieldSelectModule from "@/views/modules/FieldSelectModule";
import TableInspectMerge from "@/components/TableInspectMerge";
import FileUploadModule from "@/views/modules/FileUploadModule.vue";
import DateSelector from "@/components/selector/DateSelector.vue";
import TableCustom from "@/components/TableCustom.vue";
import SignField from "@/components/SignField.vue";
import PhotoUploadGridModule from "@/views/modules/PhotoUploadGridModule.vue";
import Print from "./Print.vue";
import TimeSelector from "@/components/selector/TimeSelector.vue";

export default {
  components: {
    TimeSelector,
    Print,
    PhotoUploadGridModule,
    SignField,
    TableCustom,
    DateSelector,
    FieldSelectModule,
    TableInspectMerge,
    FileUploadModule,
  },
  props: {
    isPrint: Boolean,
    board: Object,
    value: Object,
  },
  watch: {
    value: {
      important: true,
      deep: true,
      handler(value) {
        const keys = Object.keys(this.form);
        for (const key of keys) {
          if (value[key]) {
            this.form[key] = value[key];
          }
        }

        if (!this.form || !this.form.inspectList || this.form.inspectList.length === 0) {
          this.form.inspectList = this.inspectTable;
        }
      },
    },
    form: {
      immediate: true,
      deep: true,
      handler(value) {
        this.$emit("input", value);
      },
    },
  },
  data() {
    return {
      form: {
        stdInfo: {},
        inspectList: [],
        photoList: [],
        fileList: [],

        etcInput: "",
        etcCheck: "",
        inputB_1: "",
        inputB_2: "",
        inputB_3: "",
        inputB_4: "",
        inputB_5: "",
        inputB_6: "",
        inputB_7: "",
        inputB_8: "",
        inputB_9: "",
        victimList: [],

        inputC_1: "",
        inputC_2: "",
        inputC_3: "",

        inputD_1: "",
        inputD_2: "",
        inputD_3: "",
        inputD_4: "",

        inputE_1: "",
      },
    };
  },
  created() {
    if (!this.form.inputB_5 || this.form.inputB_5 === "") {
      this.form.inputB_5 = "유";
    }

    if (!this.form.inputB_6 || this.form.inputB_6 === "") {
      this.form.inputB_6 = "유";
    }
  },
  computed: {
    inspectTable() {
      return [
        {
          title: "기계·기구",
          content: "1. 위험기계·기구상태",
          isChecked: "",
        },
        {
          title: "기계·기구",
          content: "2. 일반동력기계·기구의 상태",
          isChecked: "",
        },
        {
          title: "기계·기구",
          content: "3. 운반기계·기구의 상태",
          isChecked: "",
        },
        {
          title: "기계·기구",
          content: "4. 수공구보관·관리상태",
          isChecked: "",
        },
        {
          title: "전기·화공",
          content: "1. 전기설비·배선상태",
          isChecked: "",
        },
        {
          title: "전기·화공",
          content: "2. 기계기구의 접지상태",
          isChecked: "",
        },
        {
          title: "전기·화공",
          content: "3. 유해물질의 취급·관리상태",
          isChecked: "",
        },
        {
          title: "전기·화공",
          content: "4. 위험물질취급·관리상태",
          isChecked: "",
        },
        {
          title: "전기·화공",
          content: "5. 가스류취급·관리상태",
          isChecked: "",
        },
        {
          title: "환경·시설물",
          content: "1. 정리정돈·청소·청결상태",
          isChecked: "",
        },
        {
          title: "환경·시설물",
          content: "2. 소음·분진·조명등상태",
          isChecked: "",
        },
        {
          title: "환경·시설물",
          content: "3. 건축구조물상태",
          isChecked: "",
        },
        {
          title: "환경·시설물",
          content: "4. 소화시설상태",
          isChecked: "",
        },
        {
          title: "환경·시설물",
          content: "5. 안전표지판관리상태",
          isChecked: "",
        },
        {
          title: "환경·시설물",
          content: "6. 적재물관리상태",
          isChecked: "",
        },
        {
          title: "작업자",
          content: "1. 작업복장상태",
          isChecked: "",
        },
        {
          title: "작업자",
          content: "2. 보호구착용상태",
          isChecked: "",
        },
        {
          title: "작업자",
          content: "3. 불안전한행동여부",
          isChecked: "",
        },
        {
          title: "작업자",
          content: "4. 작업점과 신체접촉여부",
          isChecked: "",
        },
        {
          title: "작업자",
          content: "5. 불안전한상태 방치여부",
          isChecked: "",
        },
        {
          title: "작업자",
          content: "6. 작업전중후 스트레칭여부",
          isChecked: "",
        },
        {
          title: "기타",
          content: "",
          contentClass: "empty-style",
          sign: [{ name: "", nameStyle: { display: "none" }, value: "", valueWidth: "100%" }],
          isChecked: "",
        },
      ];
    },
  },
  methods: {
    checkEtc(text) {
      this.form.etcCheck = text;
    },
  },
};
</script>